import React from "react";
import { Container, Section, PageHero, Card, Eyebrow, CTABand } from "@/components/ui-bits/Primitives";
import { CAREERS, IMAGES } from "@/lib/site-data";
import { Briefcase, ShieldCheck, GraduationCap, Mail } from "lucide-react";

export default function Careers() {
    return (
        <div data-testid="careers-page">
            <PageHero
                kicker="Careers"
                title="Build infrastructure that lasts."
                lead="Join a veteran-owned team delivering EV charging across Texas — and shape the next generation of American infrastructure."
                image={IMAGES.teamCollab}
            />

            <Section>
                <Container>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
                        {[
                            { icon: ShieldCheck, k: "Veteran Hiring Initiative", v: "We actively recruit and prioritize qualified veterans across engineering, operations, and field roles." },
                            { icon: GraduationCap, k: "Internships", v: "Hands-on internship program for STEM and policy students focused on real grant and engineering work." },
                            { icon: Briefcase, k: "Field & Office", v: "Roles span the full deployment lifecycle — from utility coordination to operations and analytics." },
                        ].map((b) => {
                            const I = b.icon;
                            return (
                                <Card key={b.k}>
                                    <I className="w-7 h-7 text-electric-400 mb-5" strokeWidth={1.5} />
                                    <h3 className="font-heading text-lg text-white">{b.k}</h3>
                                    <p className="mt-3 text-sm text-slate-400 leading-relaxed">{b.v}</p>
                                </Card>
                            );
                        })}
                    </div>

                    <Eyebrow className="mb-6">Open Positions</Eyebrow>
                    <div className="border border-white/10">
                        {CAREERS.map((c, i) => (
                            <div key={c.title} className={`grid grid-cols-1 md:grid-cols-12 gap-4 p-6 ${i !== CAREERS.length - 1 ? "border-b border-white/10" : ""} hover:bg-white/[0.02] transition-colors`}>
                                <div className="md:col-span-5">
                                    <div className="font-heading text-lg text-white">{c.title}</div>
                                    <div className="text-xs uppercase tracking-[0.18em] text-electric-400 mt-1">{c.team}</div>
                                </div>
                                <div className="md:col-span-3 text-sm text-slate-400 flex items-center">{c.location}</div>
                                <div className="md:col-span-2 text-sm text-slate-400 flex items-center">{c.type}</div>
                                <div className="md:col-span-2 flex items-center justify-start md:justify-end">
                                    <a data-testid={`career-apply-${i}`} href="mailto:oross@mclassevcharging.com?subject=Application" className="btn-ghost">Apply <Mail className="w-4 h-4" /></a>
                                </div>
                            </div>
                        ))}
                    </div>
                </Container>
            </Section>

            <CTABand title="Don't see your role?" subtitle="We always want to meet exceptional candidates." primaryLabel="Send Your Resume" />
        </div>
    );
}
